// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"0e75e1f1","394":"5f0121a9","477":"63ecfb64","515":"bdc07acd","538":"f28a1f2c","679":"896822b4","932":"bf66daaa"}[chunkId] + ".chunk.js";
};